import { Injectable } from '@angular/core';
import { AngularFirestore} from '@angular/fire/firestore'
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class FirestoreService {


  constructor(private firestore: AngularFirestore) { }

  getItem<T>(path: string): Observable<T[]> {
    const art = this.firestore.collection<T>(path, ref => ref.where('active', '==', true )).valueChanges()
    return art
  }


 filterItem<T>(filter: string): Observable<T[]> {
    const art = this.firestore.collection<T>(filter, ref => ref.where('type', '==', filter )).valueChanges()
    return art
  }
  filterartwork<T>(filter: string): Observable<T[]> {
    const art = this.firestore.collection<T>(filter, ref => ref.where('type', '==', 'artwork' )).valueChanges()
    return art
  }
  filterillust<T>(filter: string): Observable<T[]> {
    const art = this.firestore.collection<T>(filter, ref => ref.where('type', '==', 'illustration' )).valueChanges()
    return art
  }
  filterbook<T>(filter: string): Observable<T[]> {
    const art = this.firestore.collection<T>(filter, ref => ref.where('type', '==', 'bookplate' )).valueChanges()
    return art
  }


}
